import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, ModalBody, Text } from '@chakra-ui/react';
import { formatDataTestId } from '@whitbread-eos/utils';
import NextLink from 'next/link';
import HeaderSideNav from '../../../HeaderLeisure/NavigationMenuMobile/HeaderSideNav';
import { containerItemStyle } from '../../../HeaderLeisure/NavigationMenuMobile/NavigationMenuMobile.style';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function MobileSideNav(_ref) {
  var _labels$map;
  var onClickHeaderTitle = _ref.onClickHeaderTitle,
    labels = _ref.labels,
    title = _ref.title,
    baseTestId = _ref.baseTestId;
  return _jsxs(_Fragment, {
    children: [_jsx(HeaderSideNav, {
      title: title,
      onClickTitle: onClickHeaderTitle
    }), _jsx(ModalBody, {
      p: "0",
      "data-testid": formatDataTestId(baseTestId, 'Container'),
      children: _jsx(Flex, {
        flexDir: "column",
        children: labels === null || labels === void 0 || (_labels$map = labels.map) === null || _labels$map === void 0 ? void 0 : _labels$map.call(labels, label => {
          var _label$navOptions$;
          return _jsx(Flex, {
            flexDir: "column",
            children: label.navOptions.map(option => {
              var _option$url;
              return _createElement(Box, _objectSpread(_objectSpread(_objectSpread({}, customContainerItemStyle), customMobileSubMenuStyle), {}, {
                key: option === null || option === void 0 ? void 0 : option.title,
                "data-testid": formatDataTestId(baseTestId, option.title)
              }), _jsx(NextLink, {
                href: (_option$url = option.url) !== null && _option$url !== void 0 ? _option$url : '/',
                passHref: true,
                legacyBehavior: true,
                children: _jsx(Text, {
                  children: option.title
                })
              }));
            })
          }, "".concat((_label$navOptions$ = label.navOptions[0]) === null || _label$navOptions$ === void 0 ? void 0 : _label$navOptions$.title));
        })
      })
    })]
  });
}
var customMobileSubMenuStyle = {
  lineHeight: '1rem',
  pl: '1rem'
};
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  flexDirection: 'column',
  ml: '0',
  pl: 'md',
  w: '100%'
});